import { NgClass } from "@angular/common";
import { Component, inject, input, ChangeDetectionStrategy, DestroyRef } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { DropdownOption } from "../../../models/ui/dropdownOption";
import { SelectChangeEvent, SelectModule } from "@openng/optimus-ui/select";
import { isSupportedLang, SupportedLang } from "../../../models/ui/supportedLangs";
import { PreferredLanguageService } from "../../../services/state/preferred-language/preferred-language.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-lang-switch",
  standalone: true,
  imports: [SelectModule, FormsModule, TranslateModule, NgClass],
  templateUrl: "./lang-switch.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./lang-switch.component.scss",
})
export class LangSwitchComponent {
  public position = input<"absolute" | "inline">("inline");
  public persistAuthenticated = input(false);
  private destroyRef = inject(DestroyRef);
  private preferredLanguage = inject(PreferredLanguageService);
  private translate = inject(TranslateService);
  public langs: DropdownOption[] = [
    { label: "common.german", value: "de" },
    { label: "common.english", value: "en" },
  ];
  public currentLang: SupportedLang = "de";

  constructor() {
    this.currentLang = isSupportedLang(this.translate.currentLang) ? this.translate.currentLang : "de";
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (isSupportedLang(event.lang)) {
        this.currentLang = event.lang;
      }
    });
  }

  /**
   * Set the language of the application according to the dropdown value
   * @param event SelectChangeEvent
   * @returns void
   */
  public changeLanguage(event: SelectChangeEvent) {
    this.preferredLanguage.select(event.value, this.persistAuthenticated());
  }
}
